import { PeopleAnalyticsChartType } from "@/pages/reporting/employee/people-analytics/people-analytics.types.ts";
import { Button, DropdownMenu, DropdownMenuItem, FontAwesomeIcon } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface VisualisationSelectorProps {
  isChart: boolean;
  chartType: PeopleAnalyticsChartType;
  chartDisabled?: boolean;
  onSelectTable: () => void;
  onSelectChart: (type: PeopleAnalyticsChartType) => void;
}

export function VisualisationSelector({
  isChart,
  chartType,
  chartDisabled = false,
  onSelectTable,
  onSelectChart,
}: VisualisationSelectorProps) {
  const { t } = useTranslation();

  const label = isChart
    ? t(`reporting:people_analytics_visualisation_${chartType}`)
    : t("common:table");

  return (
    <DropdownMenu
      trigger={
        <Button
          variant="secondary"
          size="sm"
          className="max-w-full"
          rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-down" />}
        >
          {label}
        </Button>
      }
    >
      <DropdownMenuItem title={t("common:table")} isSelected={!isChart} onClick={onSelectTable} />
      {Object.values(PeopleAnalyticsChartType).map((value) => (
        <DropdownMenuItem
          key={value}
          title={t(`reporting:people_analytics_visualisation_${value}`)}
          isSelected={isChart && chartType === value}
          disabled={chartDisabled}
          description={
            chartDisabled ? t("reporting:people_analytics_chart_unavailable_employee") : undefined
          }
          onClick={() => onSelectChart(value)}
        />
      ))}
    </DropdownMenu>
  );
}
